import { useGlobalLoadingStore } from "@/stores/use-global-loading-store";
import { Spinner } from "@/components/ui/spinner"; // 사용 중인 Spinner 컴포넌트

export function GlobalLoadingSpinner() {
  const { loading, message, subMessage } = useGlobalLoadingStore();

  if (!loading) return null;

  return (
    <div className="fixed inset-0 z-90 flex flex-col items-center justify-center bg-black/30">
      <div className="bg-opacity-90 flex flex-col items-center space-y-2 rounded-lg bg-gray-100 p-6 dark:bg-gray-800">
        <div className="text-xl font-bold text-blue-400 dark:text-blue-300">
          {message}
        </div>
        <div className="text-muted-foreground dark:text-muted-foreground-dark text-sm">
          {subMessage}
        </div>
        <Spinner className="h-12 w-12 text-black dark:text-white" />
      </div>
    </div>
  );
}
